export class StationUnit {
	constructor(passport) {
		this.metrics = new Map()
		this._passport = passport
	}

	// Passport keys in DB
	static get passportKeys() {
		return {
			self: '', // unit key in station passport
			unitVersion: 'unit_version',
			unitPort: 'unit_port',
			unitModbusAddr: 'unit_modbus_addr',
		}
	}

	// Metric keys in DB
	static get metricKeys() {
		return {
			isConnect: 'is_connection',
		}
	}

	// Unit versions
	static get versions() {
		return {
			unknown: 'unknown',
		}
	}

	// Unit version names
	static get versionNames() {
		return {}
	}

	// Unit setting names for interface
	static get settingNames() {
		return {}
	}

	static connectionText(flag) {
        return StationUnit.flagText(flag)
    }

	static flagText(flag) {
		if (typeof flag === "boolean")
            return flag ? 'є' : 'немає'
        else
            return '-'
	}
	
	getMetric(metricName) {
		return this.metrics.get(metricName)
	}

	getMetricValue(metricName, fixed=null) {
		const metric = this.metrics.get(metricName)

		if (metric === undefined) {
			return ''
		}

		if (typeof metric == 'object') {
			if (fixed !== null) {
				return metric.value.toFixed(fixed)
			} else {
				return metric.value
			}
		} else {
			console.error('Try to get unknown metric type', metric)
			return ''
		}
	}
}